export const page = ({ theme: { colors } }) => ({
    backgroundColor: colors.white,
    margin: '0 0 20px',
    borderRadius: 6,
});

export const chart = () => ({
    padding: '22px 30px 16px',
});
